module.exports = __webpack_public_path__ + "static/media/welcome-3.f3e89e31.svg";